import { Link } from 'react-router-dom';
import { Badge } from '@v2/design-system';
import { useI18n } from '@v2/providers/I18nProvider';

export type StockPhase = 'terra' | 'transito';

type BadgeProps = {
    phase: StockPhase | string | null | undefined;
    label?: string | null;
    size?: 'sm' | 'md';
};

/** Badge Estoque (terra) × Trânsito — tipagem de unidade ou origem da reserva. */
export function StockPhaseBadge({ phase, label, size = 'sm' }: BadgeProps) {
    const { t } = useI18n();
    const isTransit = phase === 'transito' || phase === 'shipment';
    const resolved = label
        ?? (isTransit ? t('v2.stock_phase.transito') : t('v2.stock_phase.terra'));

    return (
        <Badge
            color={isTransit ? 'info' : 'success'}
            variant="flat"
            rounded="pill"
            size={size}
        >
            {resolved}
        </Badge>
    );
}

type ShipmentLinkProps = {
    shipmentId?: number | null;
    label?: string | null;
    className?: string;
};

/** Número do processo com link para o embarque. */
export function StockShipmentLink({ shipmentId, label, className }: ShipmentLinkProps) {
    if (! shipmentId) {
        return <span className={className ?? 'text-xs text-gray-400'}>—</span>;
    }

    const text = label || `#${shipmentId}`;

    return (
        <Link
            to={`/shipments/${shipmentId}`}
            className={className ?? 'font-mono text-xs font-semibold text-amber-700 hover:underline dark:text-[#C9A84C]'}
            onClick={(e) => e.stopPropagation()}
        >
            {text}
        </Link>
    );
}

export function phaseFromSource(source?: string | null): StockPhase {
    return source === 'shipment' ? 'transito' : 'terra';
}
